module.exports = __webpack_public_path__ + "static/media/alert_sante_securite.eb261c96.png";